// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_styles_dashboard__KY-3n","dashboardContainer":"Dashboard_styles_dashboardContainer__CgEef"};